import { REGIONS } from "../../../../consts/const";
import useRegionStore from "../../../../store/useRegionStore";
import { StyledMap } from "./style";

export const Map = () => {
  const { selectedRegion, setSelectedRegion } = useRegionStore();

  const mapClickEvent = (e) => {
    const id = e.target.id;
    for (var j = 0; j < REGIONS.length; j++) {
      if (REGIONS[j].key == id) {
        setSelectedRegion(REGIONS[j].value);
        document.getElementById(id + "div").style.background =
          "url(./image/map/click/click2_" + id + ".png)";
        document.getElementById(id + "div").style.backgroundSize = "cover";
        document.getElementById(id + "div").style.backgroundRepeat =
          "no-repeat";
        document.getElementById(id + "div").style.zIndex = 9;
        document.getElementById(id + "panel").style.zIndex = 9;
        document.querySelector(`#${id}div .x-form-item-body`).style.color =
          "#fff";
      } else {
        document.getElementById(REGIONS[j].key + "div").style.background =
          "url(./image/map/basic/basic2_" + REGIONS[j].key + ".png)";
        document.getElementById(REGIONS[j].key + "div").style.backgroundSize =
          "contain";
        document.getElementById(REGIONS[j].key + "div").style.backgroundRepeat =
          "no-repeat";
        document.getElementById(REGIONS[j].key + "div").style.zIndex = 8;
        document.getElementById(REGIONS[j].key + "panel").style.zIndex = 8;
        document.querySelector(
          `#${REGIONS[j].key}div .x-form-item-body`
        ).style.color = "#000";
      }
    }
  };

  const mapOnMouseOver = (e) => {
    const id = e.target.id;
    const targetRegion = REGIONS.find((region) => region.key === id);
    if (selectedRegion !== targetRegion.value) {
      document.getElementById(id + "div").style.background =
        "url(./image/map/hover/hover4_" + id + ".png)";
      document.getElementById(id + "div").style.backgroundSize =
        "contain, contain";
      document.getElementById(id + "div").style.backgroundRepeat =
        "no-repeat, no-repeat";
      document.getElementById(id + "div").style.zIndex = 9;
      document.getElementById(id + "panel").style.zIndex = 9;
    }
  };
  const mapOnMouseOut = (e) => {
    //지도에서 클릭시 호출되는 함수 중 그 지역 나갈때 불러와지는 함수
    const id = e.target.id;
    const targetRegion = REGIONS.find((region) => region.key === id);
    if (selectedRegion !== targetRegion.value) {
      document.getElementById(id + "div").style.background =
        "url(./image/map/basic/basic2_" + id + ".png)";
      document.getElementById(id + "div").style.backgroundSize = "contain";
      document.getElementById(id + "div").style.backgroundRepeat = "no-repeat";
      document.getElementById(id + "div").style.zIndex = 8;
      document.getElementById(id + "panel").style.zIndex = 8;
    }
  };
  return (
    <StyledMap>
      <div id="ManagementMap">
        <div id="container">
          <div
            className="x-center-target"
            id="potholeDsMainMapMcoView-targetE1"
            role="presentation"
            style={{
              position: "relative",
            }}
          >
            <img
              id="allmap"
              src="./image/map/전체지도.png"
              style={{
                display: "block",
                opacity: "0",
                position: "relative",
                zIndex: "10",
              }}
              useMap="#dsMainMapMcoDot"
            />
            <map id="dsMainMapMcoDot" name="dsMainMapMcoDot">
              <area
                coords="118,306,114,295,107,284,105,273,109,267,111,262,108,260,102,262,100,267,93,264,93,257,95,249,96,244,104,244,111,245,113,240,106,237,100,237,97,232,99,226,98,222,93,224,91,227,85,219,86,213,88,206,73,204,65,208,60,213,51,211,45,206,53,203,62,199,69,197,57,186,52,182,53,174,52,164,49,157,49,149,56,143,66,143,69,147,72,150,76,152,81,153,86,155,88,153,93,159,94,166,96,172,103,176,109,180,109,188,110,194,121,205,129,210,140,212,148,212,153,210,158,203,162,200,166,193,162,189,174,189,175,194,182,198,189,198,195,203,195,209,196,215,209,216,238,219,246,227,245,251,238,259,238,259,228,269,222,278,207,279,185,302,161,298,128,303,118,306"
                id="suwon"
                onClick={(e) => mapClickEvent(e)}
                onMouseOut={(e) => mapOnMouseOut(e)}
                onMouseEnter={(e) => mapOnMouseOver(e)}
                shape="poly"
                style={{
                  cursor: "pointer",
                }}
              />
              <area
                coords="236,211,209,209,192,205,197,194,185,189,177,189,170,183,166,181,162,184,158,179,156,169,149,161,141,162,136,168,128,169,123,177,121,180,113,173,112,169,99,163,99,151,91,143,94,132,94,120,92,115,111,109,114,106,115,101,121,96,121,92,118,90,133,82,140,66,146,69,154,64,162,69,165,80,176,81,182,87,187,92,195,91,204,99,207,105,215,113,221,123,218,132,212,137,218,168,222,174,253,187,254,191,249,196,250,210,248,218,236,211"
                id="uijeongbu"
                onClick={(e) => mapClickEvent(e)}
                onMouseOut={(e) => mapOnMouseOut(e)}
                onMouseEnter={(e) => mapOnMouseOver(e)}
                shape="poly"
                style={{
                  cursor: "pointer",
                }}
              />
              <area
                coords="247,235,255,216,257,206,262,195,260,185,254,179,246,177,240,176,235,173,226,171,220,168,218,160,218,149,217,140,216,137,224,132,228,126,228,119,222,112,214,106,207,103,205,98,204,88,194,86,186,86,182,84,179,76,171,78,165,68,157,60,155,55,166,53,172,48,183,51,191,52,200,49,211,51,225,44,237,51,246,51,257,53,263,55,269,52,275,48,280,54,290,56,295,52,298,47,307,48,312,40,317,40,320,47,325,56,324,62,320,69,317,75,316,84,317,97,326,102,330,108,331,117,328,123,322,130,325,141,320,150,325,161,320,168,323,183,325,192,315,202,318,212,309,216,304,224,299,231,299,237,308,237,306,243,296,245,288,249,280,245,270,246,263,253,250,252,249,241,247,235"
                id="hongcheon"
                onClick={(e) => mapClickEvent(e)}
                onMouseOut={(e) => mapOnMouseOut(e)}
                onMouseEnter={(e) => mapOnMouseOver(e)}
                shape="poly"
                style={{
                  cursor: "pointer",
                }}
              />
              <area
                coords="326,162,327,153,323,150,328,143,326,137,330,127,332,117,333,109,328,100,319,93,320,80,325,70,329,60,329,50,320,40,319,36,325,30,329,23,334,7,337,3,343,17,350,33,365,62,429,165,446,192,458,220,476,249,467,262,459,268,454,276,444,270,438,263,442,251,447,250,441,240,438,222,442,212,432,202,422,205,420,192,412,187,407,182,399,188,395,191,380,187,363,185,358,200,355,199,353,184,342,184,338,191,329,194,323,192,322,182,325,171,326,162"
                id="gangneung"
                onClick={(e) => mapClickEvent(e)}
                onMouseOut={(e) => mapOnMouseOut(e)}
                onMouseEnter={(e) => mapOnMouseOver(e)}
                shape="poly"
                style={{
                  cursor: "pointer",
                }}
              />
              <area
                coords="393,270,382,274,364,271,347,265,334,260,322,257,318,245,312,241,301,237,307,227,312,215,320,211,318,201,340,192,344,184,354,187,353,202,360,200,365,189,371,185,392,191,399,194,404,186,407,183,413,189,420,196,421,205,434,208,440,212,437,223,440,242,444,247,437,257,436,269,393,270"
                id="jeongseon"
                onClick={(e) => mapClickEvent(e)}
                onMouseOut={(e) => mapOnMouseOut(e)}
                onMouseEnter={(e) => mapOnMouseOver(e)}
                shape="poly"
                style={{
                  cursor: "pointer",
                }}
              />
              <area
                coords="73,420,74,412,71,405,76,402,65,395,62,359,44,358,34,338,15,332,24,305,42,304,49,293,45,287,62,282,69,275,109,289,119,304,136,296,160,296,179,301,186,315,195,325,182,337,165,336,157,334,142,343,132,351,129,359,118,364,104,373,96,382,95,393,99,419,93,428,82,431,73,420"
                id="yesan"
                onClick={(e) => mapClickEvent(e)}
                onMouseOut={(e) => mapOnMouseOut(e)}
                onMouseEnter={(e) => mapOnMouseOver(e)}
                shape="poly"
                style={{
                  cursor: "pointer",
                }}
              />
              <area
                coords="236,454,227,451,223,436,227,426,213,418,208,410,216,391,205,384,197,379,193,365,184,363,182,338,186,330,197,331,198,322,188,322,183,310,187,293,196,288,205,293,209,300,219,308,219,323,227,339,237,343,242,350,259,364,264,368,263,391,260,414,285,420,288,424,280,428,275,450,257,459,236,454"
                id="boeun"
                onClick={(e) => mapClickEvent(e)}
                onMouseOut={(e) => mapOnMouseOut(e)}
                onMouseEnter={(e) => mapOnMouseOver(e)}
                shape="poly"
                style={{
                  cursor: "pointer",
                }}
              />
              <area
                coords="259,348,254,358,245,352,239,340,228,335,223,332,218,318,224,311,217,300,207,295,203,283,207,275,223,275,235,260,244,256,265,259,272,251,283,246,293,253,311,246,322,248,321,261,334,262,349,269,361,272,365,277,354,286,345,295,341,302,343,312,338,318,327,313,321,308,315,308,309,318,287,319,286,331,270,339,266,340,269,351,259,348"
                id="chungju"
                onClick={(e) => mapClickEvent(e)}
                onMouseOut={(e) => mapOnMouseOut(e)}
                onMouseEnter={(e) => mapOnMouseOver(e)}
                shape="poly"
                style={{
                  cursor: "pointer",
                }}
              />
              <area
                coords="296,378,292,370,278,369,275,358,272,339,283,327,305,318,323,310,339,318,345,300,367,281,384,273,424,273,444,273,438,284,441,300,457,311,466,319,462,337,458,347,457,364,457,370,429,361,421,360,421,379,421,396,414,406,396,403,385,398,374,394,359,374,328,370,324,378,318,370,306,379,296,378"
                id="yeongju"
                onClick={(e) => mapClickEvent(e)}
                onMouseOut={(e) => mapOnMouseOut(e)}
                onMouseEnter={(e) => mapOnMouseOver(e)}
                shape="poly"
                style={{
                  cursor: "pointer",
                }}
              />
              <area
                coords="395,490,390,475,387,462,387,449,397,445,401,443,401,444,408,435,410,432,409,414,417,403,425,386,419,362,425,354,438,366,448,371,457,367,457,353,465,340,468,323,464,316,464,308,447,304,442,292,438,282,451,277,462,266,476,259,487,282,494,342,487,404,483,449,482,460,497,452,505,449,507,470,492,525,465,521,429,514,408,501,397,487,397,487,397,486,395,486,395,486,397,487,388,463,385,452,395,441,404,488,407,497,407,497,414,506,414,506,395,490"
                id="pohang"
                onClick={(e) => mapClickEvent(e)}
                onMouseOut={(e) => mapOnMouseOut(e)}
                onMouseEnter={(e) => mapOnMouseOver(e)}
                shape="poly"
                style={{
                  cursor: "pointer",
                }}
              />
              <area
                coords="91,460,84,445,78,441,71,431,87,431,99,427,100,417,99,400,98,390,95,381,106,373,130,361,135,350,148,346,153,334,168,335,181,348,189,365,193,380,184,387,178,394,178,412,183,423,188,424,197,424,202,428,212,421,221,427,229,453,222,460,208,463,198,457,192,448,186,443,155,448,142,439,122,441,111,455,100,458,94,465,91,460"
                id="nonsan"
                onClick={(e) => mapClickEvent(e)}
                onMouseOut={(e) => mapOnMouseOut(e)}
                onMouseEnter={(e) => mapOnMouseOver(e)}
                shape="poly"
                style={{
                  cursor: "pointer",
                }}
              />
              <area
                coords="321,522,309,523,313,510,305,502,297,491,279,489,272,484,266,478,265,459,275,449,280,431,290,424,280,417,266,413,263,406,267,378,264,369,258,360,265,353,271,361,275,369,286,372,296,381,305,383,315,379,316,369,325,380,329,373,358,378,375,391,399,408,408,422,410,434,404,442,392,444,384,446,382,462,434,525,391,538,362,533,338,477,340,488,348,492,349,493,339,501,344,512,333,516,340,527,327,525,321,522"
                id="daegu"
                onClick={(e) => mapClickEvent(e)}
                onMouseOut={(e) => mapOnMouseOut(e)}
                onMouseEnter={(e) => mapOnMouseOver(e)}
                shape="poly"
                style={{
                  cursor: "pointer",
                }}
              />
              <area
                coords="70,569,60,559,68,547,83,543,85,539,71,537,64,532,72,522,80,512,86,499,97,498,91,486,84,479,82,473,71,474,87,466,105,463,119,449,128,440,146,443,154,449,175,447,189,444,193,461,185,475,187,489,177,500,174,507,173,514,162,510,155,517,153,531,143,534,135,540,123,553,113,558,105,557,96,571,83,578,71,574,65,565,70,569"
                id="jeonju"
                onClick={(e) => mapClickEvent(e)}
                onMouseOut={(e) => mapOnMouseOut(e)}
                onMouseEnter={(e) => mapOnMouseOver(e)}
                shape="poly"
                style={{
                  cursor: "pointer",
                }}
              />
              <area
                coords="190,576,176,579,157,575,148,579,145,559,137,564,127,563,132,551,143,533,149,539,155,530,159,511,172,519,181,495,187,484,189,475,187,464,199,463,214,467,223,462,235,454,254,462,263,464,262,478,244,492,231,510,223,539,228,553,229,570,224,579,216,579,211,571,199,571,190,576"
                id="namwon"
                onClick={(e) => mapClickEvent(e)}
                onMouseOut={(e) => mapOnMouseOut(e)}
                onMouseEnter={(e) => mapOnMouseOver(e)}
                shape="poly"
                style={{
                  cursor: "pointer",
                }}
              />
              <area
                coords="76,756,16,754,3,743,21,725,27,712,40,681,52,637,58,617,40,601,58,565,74,580,88,584,98,575,106,561,114,555,128,566,135,566,141,561,150,575,146,590,153,599,162,606,160,639,147,644,141,664,114,658,97,682,103,688,104,729,76,756"
                id="gwangju"
                onClick={(e) => mapClickEvent(e)}
                onMouseOut={(e) => mapOnMouseOut(e)}
                onMouseEnter={(e) => mapOnMouseOver(e)}
                shape="poly"
                style={{
                  cursor: "pointer",
                }}
              />
              <area
                coords="209,658,192,667,191,681,208,701,202,709,196,709,184,729,173,719,153,713,115,732,99,713,106,690,98,680,114,659,126,663,137,666,147,652,160,638,161,617,163,600,151,597,148,586,155,576,176,583,192,578,208,572,221,586,245,637,235,647,220,655,243,660,246,674,233,683,225,689,216,692,217,670,209,658"
                id="suncheon"
                onClick={(e) => mapClickEvent(e)}
                onMouseOut={(e) => mapOnMouseOut(e)}
                onMouseEnter={(e) => mapOnMouseOver(e)}
                shape="poly"
                style={{
                  cursor: "pointer",
                }}
              />
              <area
                coords="304,656,291,654,287,646,287,632,282,633,287,644,267,637,266,645,250,648,249,638,238,623,227,607,220,587,228,569,229,555,226,540,234,513,250,491,266,483,282,493,300,500,310,510,308,526,325,529,334,541,339,556,342,572,329,579,324,597,332,607,340,608,348,625,354,635,340,659,325,660,304,656"
                id="jinju"
                onClick={(e) => mapClickEvent(e)}
                onMouseOut={(e) => mapOnMouseOut(e)}
                onMouseEnter={(e) => mapOnMouseOver(e)}
                shape="poly"
                style={{
                  cursor: "pointer",
                }}
              />
              <area
                coords="368,612,371,623,362,625,354,623,342,617,345,605,335,602,326,596,331,578,339,578,345,569,342,561,343,551,335,537,341,529,353,526,362,536,376,538,390,541,410,529,424,531,438,522,442,512,460,519,465,525,485,526,492,544,485,554,471,588,455,609,455,610,435,625,412,628,392,626,379,622,368,612"
                id="jinyeong"
                onClick={(e) => mapClickEvent(e)}
                onMouseOut={(e) => mapOnMouseOut(e)}
                onMouseEnter={(e) => mapOnMouseOver(e)}
                shape="poly"
                style={{
                  cursor: "pointer",
                }}
              />
            </map>
            <div
              className="x-panel x-center-layout-item x-panel-default"
              id="suwonpanel"
              role="presentation"
              style={{
                height: "130px",
                left: "35px",
                margin: "0px",
                right: "auto",
                top: "108px",
                width: "159px",
                zIndex: "8",
              }}
            >
              <div
                className="x-panel-body x-panel-body-default x-panel-body-default x-noborder-trbl"
                data-ref="body"
                id="suwondiv"
                role="presentation"
                style={{
                  background: "url(./image/map/basic/basic2_suwon.png)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  height: "128px",
                  left: "0px",
                  top: "0px",
                  width: "156px",
                  zIndex: "8",
                }}
              >
                <div
                  className="x-center-target"
                  id="panel-1160-targetEl"
                  role="presentation"
                >
                  <div
                    className="x-field x-form-item x-form-item-default x-form-readonly x-form-type-text x-center-layout-item x-field-default x-center-form-item x-form-item-no-label"
                    id="displayfield-1161"
                    role="presentation"
                    style={{
                      left: "67px",
                      margin: "0px",
                      right: "auto",
                      top: "58px",
                    }}
                  >
                    <div
                      className="x-form-item-body x-form-item-body-default x-form-display-field-body x-form-display-field-body-default"
                      data-ref="bodyEl"
                      id="displayfield-1161-bodyEl"
                      role="presentation"
                    >
                      <div
                        aria-labelledby="displayfield-1161-labelEl"
                        className="dsCenterMapLabel dsCenterMapLabel-default"
                        data-ref="inputEl"
                        id="displayfield-1161-inputEl"
                        role="textbox"
                        tabIndex="-1"
                      >
                        수원
                      </div>
                      <div
                        aria-live="polite"
                        className="x-hidden-clip"
                        data-ref="ariaErrorEl"
                        id="displayfield-1161-ariaErrorEl"
                        role="alert"
                      />
                    </div>
                    <div
                      className="x-form-error-wrap x-form-error-wrap-default x-form-error-wrap-side"
                      data-ref="errorWrapEl"
                      id="displayfield-1161-errorWrapEl"
                      style={{
                        display: "none",
                      }}
                    >
                      <div
                        className="x-form-error-msg x-form-invalid-icon x-form-invalid-icon-default"
                        data-anchortarget="displayfield-1161-inputEl"
                        data-ref="errorEl"
                        id="displayfield-1161-errorEl"
                        role="presentation"
                      />
                    </div>
                  </div>
                  <div
                    className="x-field x-form-item x-form-item-default x-form-readonly x-form-type-text x-center-layout-item x-field-default x-center-form-item x-form-item-no-label"
                    id="DsMainMapMcoValue1"
                    role="presentation"
                    style={{
                      left: "71px",
                      margin: "0px",
                      right: "auto",
                      top: "78px",
                    }}
                  >
                    <div
                      className="x-form-item-body x-form-item-body-default x-form-display-field-body x-form-display-field-body-default"
                      data-ref="bodyEl"
                      id="DsMainMapMcoValue1-bodyEl"
                      role="presentation"
                    >
                      <div
                        className="dsCenterMapLabel dsCenterMapLabel-default"
                        data-ref="inputEl"
                        id="suwonPotNumber"
                        role="presentation"
                        tabIndex="-1"
                      />
                      <div
                        aria-live="polite"
                        className="x-hidden-clip"
                        data-ref="ariaErrorEl"
                        id="DsMainMapMcoValue1-ariaErrorEl"
                        role="alert"
                      />
                    </div>
                    <div
                      className="x-form-error-wrap x-form-error-wrap-default x-form-error-wrap-side"
                      data-ref="errorWrapEl"
                      id="DsMainMapMcoValue1-errorWrapEl"
                      style={{
                        display: "none",
                      }}
                    >
                      <div
                        className="x-form-error-msg x-form-invalid-icon x-form-invalid-icon-default"
                        data-anchortarget="DsMainMapMcoValue1-inputEl"
                        data-ref="errorEl"
                        id="DsMainMapMcoValue1-errorEl"
                        role="presentation"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="x-panel x-center-layout-item x-panel-default"
              id="uijeongbupanel"
              role="presentation"
              style={{
                height: "120px",
                left: "70px",
                margin: "0px",
                right: "auto",
                top: "49px",
                width: "131px",
                zIndex: "8",
              }}
            >
              <div
                className="x-panel-body x-panel-body-default x-panel-body-default x-noborder-trbl"
                data-ref="body"
                id="uijeongbudiv"
                role="presentation"
                style={{
                  background: "url(./image/map/basic/basic2_uijeongbu.png)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  height: "122px",
                  left: "0px",
                  top: "0px",
                  width: "129px",
                  zIndex: "8",
                }}
              >
                <div
                  className="x-center-target"
                  id="panel-1162-targetEl"
                  role="presentation"
                >
                  <div
                    className="x-field x-form-item x-form-item-default x-form-readonly x-form-type-text x-center-layout-item x-field-default x-center-form-item x-form-item-no-label"
                    id="displayfield-1163"
                    role="presentation"
                    style={{
                      left: "39px",
                      margin: "0px",
                      right: "auto",
                      top: "35px",
                    }}
                  >
                    <div
                      className="x-form-item-body x-form-item-body-default x-form-display-field-body x-form-display-field-body-default"
                      data-ref="bodyEl"
                      id="displayfield-1163-bodyEl"
                      role="presentation"
                    >
                      <div
                        aria-labelledby="displayfield-1163-labelEl"
                        className="dsCenterMapLabel dsCenterMapLabel-default"
                        data-ref="inputEl"
                        id="displayfield-1163-inputEl"
                        role="textbox"
                        tabIndex="-1"
                      >
                        의정부
                      </div>
                      <div
                        aria-live="polite"
                        className="x-hidden-clip"
                        data-ref="ariaErrorEl"
                        id="displayfield-1163-ariaErrorEl"
                        role="alert"
                      />
                    </div>
                    <div
                      className="x-form-error-wrap x-form-error-wrap-default x-form-error-wrap-side"
                      data-ref="errorWrapEl"
                      id="displayfield-1163-errorWrapEl"
                      style={{
                        display: "none",
                      }}
                    >
                      <div
                        className="x-form-error-msg x-form-invalid-icon x-form-invalid-icon-default"
                        data-anchortarget="displayfield-1163-inputEl"
                        data-ref="errorEl"
                        id="displayfield-1163-errorEl"
                        role="presentation"
                      />
                    </div>
                  </div>
                  <div
                    className="x-field x-form-item x-form-item-default x-form-readonly x-form-type-text x-center-layout-item x-field-default x-center-form-item x-form-item-no-label"
                    id="DsMainMapMcoValue2"
                    role="presentation"
                    style={{
                      left: "53px",
                      margin: "0px",
                      right: "auto",
                      top: "55px",
                    }}
                  >
                    <div
                      className="x-form-item-body x-form-item-body-default x-form-display-field-body x-form-display-field-body-default"
                      data-ref="bodyEl"
                      id="DsMainMapMcoValue2-bodyEl"
                      role="presentation"
                    >
                      <div
                        aria-labelledby="DsMainMapMcoValue2-labelEl"
                        className="dsCenterMapLabel dsCenterMapLabel-default"
                        data-ref="inputEl"
                        id="uijeongbuPotNumber"
                        role="textbox"
                        tabIndex="-1"
                      />
                      <div
                        aria-live="polite"
                        className="x-hidden-clip"
                        data-ref="ariaErrorEl"
                        id="DsMainMapMcoValue2-ariaErrorEl"
                        role="alert"
                      />
                    </div>
                    <div
                      className="x-form-error-wrap x-form-error-wrap-default x-form-error-wrap-side"
                      data-ref="errorWrapEl"
                      id="DsMainMapMcoValue2-errorWrapEl"
                      style={{
                        display: "none",
                      }}
                    >
                      <div
                        className="x-form-error-msg x-form-invalid-icon x-form-invalid-icon-default"
                        data-anchortarget="DsMainMapMcoValue2-inputEl"
                        data-ref="errorEl"
                        id="DsMainMapMcoValue2-errorEl"
                        role="presentation"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="x-panel x-center-layout-item x-panel-default"
              id="hongcheonpanel"
              role="presentation"
              style={{
                height: "168px",
                left: "120px",
                margin: "0px",
                right: "auto",
                top: "29px",
                width: "139px",
                zIndex: "8",
              }}
            >
              <div
                className="x-panel-body x-panel-body-default x-panel-body-default x-noborder-trbl"
                data-ref="body"
                id="hongcheondiv"
                role="presentation"
                style={{
                  background: "url(./image/map/basic/basic2_hongcheon.png)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  height: "170px",
                  left: "0px",
                  top: "0px",
                  width: "136px",
                  zIndex: "8",
                }}
              >
                <div
                  className="x-center-target"
                  id="panel-1164-targetEl"
                  role="presentation"
                >
                  <div
                    className="x-field x-form-item x-form-item-default x-form-readonly x-form-type-text x-center-layout-item x-field-default x-center-form-item x-form-item-no-label"
                    id="displayfield-1165"
                    role="presentation"
                    style={{
                      left: "69px",
                      margin: "0px",
                      right: "auto",
                      top: "45px",
                    }}
                  >
                    <div
                      className="x-form-item-body x-form-item-body-default x-form-display-field-body x-form-display-field-body-default"
                      data-ref="bodyEl"
                      id="displayfield-1165-bodyEl"
                      role="presentation"
                    >
                      <div
                        aria-labelledby="displayfield-1165-labelEl"
                        className="dsCenterMapLabel dsCenterMapLabel-default"
                        data-ref="inputEl"
                        id="displayfield-1165-inputEl"
                        role="textbox"
                        tabIndex="-1"
                      >
                        홍천
                      </div>
                      <div
                        aria-live="polite"
                        className="x-hidden-clip"
                        data-ref="ariaErrorEl"
                        id="displayfield-1165-ariaErrorEl"
                        role="alert"
                      />
                    </div>
                    <div
                      className="x-form-error-wrap x-form-error-wrap-default x-form-error-wrap-side"
                      data-ref="errorWrapEl"
                      id="displayfield-1165-errorWrapEl"
                      style={{
                        display: "none",
                      }}
                    >
                      <div
                        className="x-form-error-msg x-form-invalid-icon x-form-invalid-icon-default"
                        data-anchortarget="displayfield-1165-inputEl"
                        data-ref="errorEl"
                        id="displayfield-1165-errorEl"
                        role="presentation"
                      />
                    </div>
                  </div>
                  <div
                    className="x-field x-form-item x-form-item-default x-form-readonly x-form-type-text x-center-layout-item x-field-default x-center-form-item x-form-item-no-label"
                    id="DsMainMapMcoValue3"
                    role="presentation"
                    style={{
                      left: "76px",
                      margin: "0px",
                      right: "auto",
                      top: "65px",
                    }}
                  >
                    <div
                      className="x-form-item-body x-form-item-body-default x-form-display-field-body x-form-display-field-body-default"
                      data-ref="bodyEl"
                      id="DsMainMapMcoValue3-bodyEl"
                      role="presentation"
                    >
                      <div
                        aria-labelledby="DsMainMapMcoValue3-labelEl"
                        className="dsCenterMapLabel dsCenterMapLabel-default"
                        data-ref="inputEl"
                        id="hongcheonPotNumber"
                        role="textbox"
                        tabIndex="-1"
                      />
                      <div
                        aria-live="polite"
                        className="x-hidden-clip"
                        data-ref="ariaErrorEl"
                        id="DsMainMapMcoValue3-ariaErrorEl"
                        role="alert"
                      />
                    </div>
                    <div
                      className="x-form-error-wrap x-form-error-wrap-default x-form-error-wrap-side"
                      data-ref="errorWrapEl"
                      id="DsMainMapMcoValue3-errorWrapEl"
                      style={{
                        display: "none",
                      }}
                    >
                      <div
                        className="x-form-error-msg x-form-invalid-icon x-form-invalid-icon-default"
                        data-anchortarget="DsMainMapMcoValue3-inputEl"
                        data-ref="errorEl"
                        id="DsMainMapMcoValue3-errorEl"
                        role="presentation"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="x-panel x-center-layout-item x-panel-default"
              id="gangneungpanel"
              role="presentation"
              style={{
                height: "215px",
                left: "246px",
                margin: "0px",
                right: "auto",
                top: "2px",
                width: "124px",
                zIndex: "8",
              }}
            >
              <div
                className="x-panel-body x-panel-body-default x-panel-body-default x-noborder-trbl"
                data-ref="body"
                id="gangneungdiv"
                role="presentation"
                style={{
                  background: "url(./image/map/basic/basic2_gangneung.png)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  height: "213px",
                  left: "0px",
                  top: "0px",
                  width: "123px",
                  zIndex: "8",
                }}
              >
                <div
                  className="x-center-target"
                  id="panel-1166-targetEl"
                  role="presentation"
                >
                  <div
                    className="x-field x-form-item x-form-item-default x-form-readonly x-form-type-text x-center-layout-item x-field-default x-center-form-item x-form-item-no-label"
                    id="displayfield-1167"
                    role="presentation"
                    style={{
                      left: "23px",
                      margin: "0px",
                      right: "auto",
                      top: "75px",
                    }}
                  >
                    <div
                      className="x-form-item-body x-form-item-body-default x-form-display-field-body x-form-display-field-body-default"
                      data-ref="bodyEl"
                      id="displayfield-1167-bodyEl"
                      role="presentation"
                    >
                      <div
                        aria-labelledby="displayfield-1167-labelEl"
                        className="dsCenterMapLabel dsCenterMapLabel-default"
                        data-ref="inputEl"
                        id="displayfield-1167-inputEl"
                        role="textbox"
                        tabIndex="-1"
                      >
                        강릉
                      </div>
                      <div
                        aria-live="polite"
                        className="x-hidden-clip"
                        data-ref="ariaErrorEl"
                        id="displayfield-1167-ariaErrorEl"
                        role="alert"
                      />
                    </div>
                    <div
                      className="x-form-error-wrap x-form-error-wrap-default x-form-error-wrap-side"
                      data-ref="errorWrapEl"
                      id="displayfield-1167-errorWrapEl"
                      style={{
                        display: "none",
                      }}
                    >
                      <div
                        className="x-form-error-msg x-form-invalid-icon x-form-invalid-icon-default"
                        data-anchortarget="displayfield-1167-inputEl"
                        data-ref="errorEl"
                        id="displayfield-1167-errorEl"
                        role="presentation"
                      />
                    </div>
                  </div>
                  <div
                    className="x-field x-form-item x-form-item-default x-form-readonly x-form-type-text x-center-layout-item x-field-default x-center-form-item x-form-item-no-label"
                    id="DsMainMapMcoValue4"
                    role="presentation"
                    style={{
                      left: "30px",
                      margin: "0px",
                      right: "auto",
                      top: "95px",
                    }}
                  >
                    <div
                      className="x-form-item-body x-form-item-body-default x-form-display-field-body x-form-display-field-body-default"
                      data-ref="bodyEl"
                      id="DsMainMapMcoValue4-bodyEl"
                      role="presentation"
                    >
                      <div
                        aria-labelledby="DsMainMapMcoValue4-labelEl"
                        className="dsCenterMapLabel dsCenterMapLabel-default"
                        data-ref="inputEl"
                        id="gangneungPotNumber"
                        role="textbox"
                        tabIndex="-1"
                      />
                      <div
                        aria-live="polite"
                        className="x-hidden-clip"
                        data-ref="ariaErrorEl"
                        id="DsMainMapMcoValue4-ariaErrorEl"
                        role="alert"
                      />
                    </div>
                    <div
                      className="x-form-error-wrap x-form-error-wrap-default x-form-error-wrap-side"
                      data-ref="errorWrapEl"
                      id="DsMainMapMcoValue4-errorWrapEl"
                      style={{
                        display: "none",
                      }}
                    >
                      <div
                        className="x-form-error-msg x-form-invalid-icon x-form-invalid-icon-default"
                        data-anchortarget="DsMainMapMcoValue4-inputEl"
                        data-ref="errorEl"
                        id="DsMainMapMcoValue4-errorEl"
                        role="presentation"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="x-panel x-center-layout-item x-panel-default"
              id="yesanpanel"
              role="presentation"
              style={{
                height: "120px",
                left: "10px",
                margin: "0px",
                right: "auto",
                top: "216px",
                width: "142px",
                zIndex: "8",
              }}
            >
              <div
                className="x-panel-body x-panel-body-default x-panel-body-default x-noborder-trbl"
                data-ref="body"
                id="yesandiv"
                role="presentation"
                style={{
                  background: "url(./image/map/basic/basic2_yesan.png)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  height: "119px",
                  left: "0px",
                  top: "0px",
                  width: "141px",
                  zIndex: "8",
                }}
              >
                <div
                  className="x-center-target"
                  id="panel-1168-targetEl"
                  role="presentation"
                >
                  <div
                    className="x-field x-form-item x-form-item-default x-form-readonly x-form-type-text x-center-layout-item x-field-default x-center-form-item x-form-item-no-label"
                    id="displayfield-1169"
                    role="presentation"
                    style={{
                      left: "40px",
                      margin: "0px",
                      right: "auto",
                      top: "24px",
                    }}
                  >
                    <div
                      className="x-form-item-body x-form-item-body-default x-form-display-field-body x-form-display-field-body-default"
                      data-ref="bodyEl"
                      id="displayfield-1169-bodyEl"
                      role="presentation"
                    >
                      <div
                        aria-labelledby="displayfield-1169-labelEl"
                        className="dsCenterMapLabel dsCenterMapLabel-default"
                        data-ref="inputEl"
                        id="displayfield-1169-inputEl"
                        role="textbox"
                        tabIndex="-1"
                      >
                        예산
                      </div>
                      <div
                        aria-live="polite"
                        className="x-hidden-clip"
                        data-ref="ariaErrorEl"
                        id="displayfield-1169-ariaErrorEl"
                        role="alert"
                      />
                    </div>
                    <div
                      className="x-form-error-wrap x-form-error-wrap-default x-form-error-wrap-side"
                      data-ref="errorWrapEl"
                      id="displayfield-1169-errorWrapEl"
                      style={{
                        display: "none",
                      }}
                    >
                      <div
                        className="x-form-error-msg x-form-invalid-icon x-form-invalid-icon-default"
                        data-anchortarget="displayfield-1169-inputEl"
                        data-ref="errorEl"
                        id="displayfield-1169-errorEl"
                        role="presentation"
                      />
                    </div>
                  </div>
                  <div
                    className="x-field x-form-item x-form-item-default x-form-readonly x-form-type-text x-center-layout-item x-field-default x-center-form-item x-form-item-no-label"
                    id="DsMainMapMcoValue5"
                    role="presentation"
                    style={{
                      left: "48px",
                      margin: "0px",
                      right: "auto",
                      top: "44px",
                    }}
                  >
                    <div
                      className="x-form-item-body x-form-item-body-default x-form-display-field-body x-form-display-field-body-default"
                      data-ref="bodyEl"
                      id="DsMainMapMcoValue5-bodyEl"
                      role="presentation"
                    >
                      <div
                        aria-labelledby="DsMainMapMcoValue5-labelEl"
                        className="dsCenterMapLabel dsCenterMapLabel-default"
                        data-ref="inputEl"
                        id="yesanPotNumber"
                        role="textbox"
                        tabIndex="-1"
                      />
                      <div
                        aria-live="polite"
                        className="x-hidden-clip"
                        data-ref="ariaErrorEl"
                        id="DsMainMapMcoValue5-ariaErrorEl"
                        role="alert"
                      />
                    </div>
                    <div
                      className="x-form-error-wrap x-form-error-wrap-default x-form-error-wrap-side"
                      data-ref="errorWrapEl"
                      id="DsMainMapMcoValue5-errorWrapEl"
                      style={{
                        display: "none",
                      }}
                    >
                      <div
                        className="x-form-error-msg x-form-invalid-icon x-form-invalid-icon-default"
                        data-anchortarget="DsMainMapMcoValue5-inputEl"
                        data-ref="errorEl"
                        id="DsMainMapMcoValue5-errorEl"
                        role="presentation"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="x-panel x-center-layout-item x-panel-default"
              id="boeunpanel"
              role="presentation"
              style={{
                height: "138px",
                left: "140px",
                margin: "0px",
                right: "auto",
                top: "222px",
                width: "84px",
                zIndex: "8",
              }}
            >
              <div
                className="x-panel-body x-panel-body-default x-panel-body-default x-noborder-trbl"
                data-ref="body"
                id="boeundiv"
                role="presentation"
                style={{
                  background: "url(./image/map/basic/basic2_boeun.png)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  height: "133px",
                  left: "0px",
                  top: "0px",
                  width: "81px",
                  zIndex: "8",
                }}
              >
                <div
                  className="x-center-target"
                  id="panel-1170-targetEl"
                  role="presentation"
                >
                  <div
                    className="x-field x-form-item x-form-item-default x-form-readonly x-form-type-text x-center-layout-item x-field-default x-center-form-item x-form-item-no-label"
                    id="displayfield-1171"
                    role="presentation"
                    style={{
                      left: "15px",
                      margin: "0px",
                      right: "auto",
                      top: "39px",
                    }}
                  >
                    <div
                      className="x-form-item-body x-form-item-body-default x-form-display-field-body x-form-display-field-body-default"
                      data-ref="bodyEl"
                      id="displayfield-1171-bodyEl"
                      role="presentation"
                    >
                      <div
                        aria-labelledby="displayfield-1171-labelEl"
                        className="dsCenterMapLabel dsCenterMapLabel-default"
                        data-ref="inputEl"
                        id=""
                        role="textbox"
                        tabIndex="-1"
                      >
                        보은
                      </div>
                      <div
                        aria-live="polite"
                        className="x-hidden-clip"
                        data-ref="ariaErrorEl"
                        id="displayfield-1171-ariaErrorEl"
                        role="alert"
                      />
                    </div>
                    <div
                      className="x-form-error-wrap x-form-error-wrap-default x-form-error-wrap-side"
                      data-ref="errorWrapEl"
                      id="displayfield-1171-errorWrapEl"
                      style={{
                        display: "none",
                      }}
                    >
                      <div
                        className="x-form-error-msg x-form-invalid-icon x-form-invalid-icon-default"
                        data-anchortarget="displayfield-1171-inputEl"
                        data-ref="errorEl"
                        id="displayfield-1171-errorEl"
                        role="presentation"
                      />
                    </div>
                  </div>
                  <div
                    className="x-field x-form-item x-form-item-default x-form-readonly x-form-type-text x-center-layout-item x-field-default x-center-form-item x-form-item-no-label"
                    id="DsMainMapMcoValue6"
                    role="presentation"
                    style={{
                      left: "19px",
                      margin: "0px",
                      right: "auto",
                      top: "59px",
                    }}
                  >
                    <div
                      className="x-form-item-body x-form-item-body-default x-form-display-field-body x-form-display-field-body-default"
                      data-ref="bodyEl"
                      id="DsMainMapMcoValue6-bodyEl"
                      role="presentation"
                    >
                      <div
                        aria-labelledby="DsMainMapMcoValue6-labelEl"
                        className="dsCenterMapLabel dsCenterMapLabel-default"
                        data-ref="inputEl"
                        id="boeunPotNumber"
                        role="textbox"
                        tabIndex="-1"
                      />
                      <div
                        aria-live="polite"
                        className="x-hidden-clip"
                        data-ref="ariaErrorEl"
                        id="DsMainMapMcoValue6-ariaErrorEl"
                        role="alert"
                      />
                    </div>
                    <div
                      className="x-form-error-wrap x-form-error-wrap-default x-form-error-wrap-side"
                      data-ref="errorWrapEl"
                      id="DsMainMapMcoValue6-errorWrapEl"
                      style={{
                        display: "none",
                      }}
                    >
                      <div
                        className="x-form-error-msg x-form-invalid-icon x-form-invalid-icon-default"
                        data-anchortarget="DsMainMapMcoValue6-inputEl"
                        data-ref="errorEl"
                        id="DsMainMapMcoValue6-errorEl"
                        role="presentation"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="x-panel x-center-layout-item x-panel-default"
              id="chungjupanel"
              role="presentation"
              style={{
                height: "90px",
                left: "160px",
                margin: "0px",
                right: "auto",
                top: "192px",
                width: "132px",
                zIndex: "8",
              }}
            >
              <div
                className="x-panel-body x-panel-body-default x-panel-body-default x-noborder-trbl"
                data-ref="body"
                id="chungjudiv"
                role="presentation"
                style={{
                  background: "url(./image/map/basic/basic2_chungju.png)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  height: "84px",
                  left: "0px",
                  top: "0px",
                  width: "126px",
                  zIndex: "8",
                }}
              >
                <div
                  className="x-center-target"
                  id="panel-1172-targetEl"
                  role="presentation"
                >
                  <div
                    className="x-field x-form-item x-form-item-default x-form-readonly x-form-type-text x-center-layout-item x-field-default x-center-form-item x-form-item-no-label"
                    id="displayfield-1173"
                    role="presentation"
                    style={{
                      left: "36px",
                      margin: "0px",
                      right: "auto",
                      top: "20px",
                    }}
                  >
                    <div
                      className="x-form-item-body x-form-item-body-default x-form-display-field-body x-form-display-field-body-default"
                      data-ref="bodyEl"
                      id="displayfield-1173-bodyEl"
                      role="presentation"
                    >
                      <div
                        aria-labelledby="displayfield-1173-labelEl"
                        className="dsCenterMapLabel dsCenterMapLabel-default"
                        data-ref="inputEl"
                        id="displayfield-1173-inputEl"
                        role="textbox"
                        tabIndex="-1"
                      >
                        충주
                      </div>
                      <div
                        aria-live="polite"
                        className="x-hidden-clip"
                        data-ref="ariaErrorEl"
                        id="displayfield-1173-ariaErrorEl"
                        role="alert"
                      />
                    </div>
                    <div
                      className="x-form-error-wrap x-form-error-wrap-default x-form-error-wrap-side"
                      data-ref="errorWrapEl"
                      id="displayfield-1173-errorWrapEl"
                      style={{
                        display: "none",
                      }}
                    >
                      <div
                        className="x-form-error-msg x-form-invalid-icon x-form-invalid-icon-default"
                        data-anchortarget="displayfield-1173-inputEl"
                        data-ref="errorEl"
                        id="displayfield-1173-errorEl"
                        role="presentation"
                      />
                    </div>
                  </div>
                  <div
                    className="x-field x-form-item x-form-item-default x-form-readonly x-form-type-text x-center-layout-item x-field-default x-center-form-item x-form-item-no-label"
                    id="DsMainMapMcoValue7"
                    role="presentation"
                    style={{
                      left: "44px",
                      margin: "0px",
                      right: "auto",
                      top: "40px",
                    }}
                  >
                    <div
                      className="x-form-item-body x-form-item-body-default x-form-display-field-body x-form-display-field-body-default"
                      data-ref="bodyEl"
                      id="DsMainMapMcoValue7-bodyEl"
                      role="presentation"
                    >
                      <div
                        aria-labelledby="DsMainMapMcoValue7-labelEl"
                        className="dsCenterMapLabel dsCenterMapLabel-default"
                        data-ref="inputEl"
                        id="chungjuPotNumber"
                        role="textbox"
                        tabIndex="-1"
                      />
                      <div
                        aria-live="polite"
                        className="x-hidden-clip"
                        data-ref="ariaErrorEl"
                        id="DsMainMapMcoValue7-ariaErrorEl"
                        role="alert"
                      />
                    </div>
                    <div
                      className="x-form-error-wrap x-form-error-wrap-default x-form-error-wrap-side"
                      data-ref="errorWrapEl"
                      id="DsMainMapMcoValue7-errorWrapEl"
                      style={{
                        display: "none",
                      }}
                    >
                      <div
                        className="x-form-error-msg x-form-invalid-icon x-form-invalid-icon-default"
                        data-anchortarget="DsMainMapMcoValue7-inputEl"
                        data-ref="errorEl"
                        id="DsMainMapMcoValue7-errorEl"
                        role="presentation"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="x-panel x-center-layout-item x-panel-default"
              id="yeongjupanel"
              role="presentation"
              style={{
                height: "105px",
                left: "211px",
                margin: "0px",
                right: "auto",
                top: "212px",
                width: "157px",
                zIndex: "8",
              }}
            >
              <div
                className="x-panel-body x-panel-body-default x-panel-body-default x-noborder-trbl"
                data-ref="body"
                id="yeongjudiv"
                role="presentation"
                style={{
                  background: "url(./image/map/basic/basic2_yeongju.png)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  height: "105px",
                  left: "0px",
                  top: "0px",
                  width: "150px",
                  zIndex: "8",
                }}
              >
                <div
                  className="x-center-target"
                  id="panel-1174-targetEl"
                  role="presentation"
                >
                  <div
                    className="x-field x-form-item x-form-item-default x-form-readonly x-form-type-text x-center-layout-item x-field-default x-center-form-item x-form-item-no-label"
                    id="displayfield-1175"
                    role="presentation"
                    style={{
                      left: "66px",
                      margin: "0px",
                      right: "auto",
                      top: "28px",
                    }}
                  >
                    <div
                      className="x-form-item-body x-form-item-body-default x-form-display-field-body x-form-display-field-body-default"
                      data-ref="bodyEl"
                      id="displayfield-1175-bodyEl"
                      role="presentation"
                    >
                      <div
                        aria-labelledby="displayfield-1175-labelEl"
                        className="dsCenterMapLabel dsCenterMapLabel-default"
                        data-ref="inputEl"
                        id="displayfield-1175-inputEl"
                        role="textbox"
                        tabIndex="-1"
                      >
                        영주
                      </div>
                      <div
                        aria-live="polite"
                        className="x-hidden-clip"
                        data-ref="ariaErrorEl"
                        id="displayfield-1175-ariaErrorEl"
                        role="alert"
                      />
                    </div>
                    <div
                      className="x-form-error-wrap x-form-error-wrap-default x-form-error-wrap-side"
                      data-ref="errorWrapEl"
                      id="displayfield-1175-errorWrapEl"
                      style={{
                        display: "none",
                      }}
                    >
                      <div
                        className="x-form-error-msg x-form-invalid-icon x-form-invalid-icon-default"
                        data-anchortarget="displayfield-1175-inputEl"
                        data-ref="errorEl"
                        id="displayfield-1175-errorEl"
                        role="presentation"
                      />
                    </div>
                  </div>
                  <div
                    className="x-field x-form-item x-form-item-default x-form-readonly x-form-type-text x-center-layout-item x-field-default x-center-form-item x-form-item-no-label"
                    id="DsMainMapMcoValue8"
                    role="presentation"
                    style={{
                      left: "73px",
                      margin: "0px",
                      right: "auto",
                      top: "48px",
                    }}
                  >
                    <div
                      className="x-form-item-body x-form-item-body-default x-form-display-field-body x-form-display-field-body-default"
                      data-ref="bodyEl"
                      id="DsMainMapMcoValue8-bodyEl"
                      role="presentation"
                    >
                      <div
                        aria-labelledby="DsMainMapMcoValue8-labelEl"
                        className="dsCenterMapLabel dsCenterMapLabel-default"
                        data-ref="inputEl"
                        id="yeongjuPotNumber"
                        role="textbox"
                        tabIndex="-1"
                      />
                      <div
                        aria-live="polite"
                        className="x-hidden-clip"
                        data-ref="ariaErrorEl"
                        id="DsMainMapMcoValue8-ariaErrorEl"
                        role="alert"
                      />
                    </div>
                    <div
                      className="x-form-error-wrap x-form-error-wrap-default x-form-error-wrap-side"
                      data-ref="errorWrapEl"
                      id="DsMainMapMcoValue8-errorWrapEl"
                      style={{
                        display: "none",
                      }}
                    >
                      <div
                        className="x-form-error-msg x-form-invalid-icon x-form-invalid-icon-default"
                        data-anchortarget="DsMainMapMcoValue8-inputEl"
                        data-ref="errorEl"
                        id="DsMainMapMcoValue8-errorEl"
                        role="presentation"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="x-panel x-center-layout-item x-panel-default"
              id="jeongseonpanel"
              role="presentation"
              style={{
                height: "74px",
                left: "233px",
                margin: "0px",
                right: "auto",
                top: "144px",
                width: "116px",
                zIndex: "8",
              }}
            >
              <div
                className="x-panel-body x-panel-body-default x-panel-body-default x-noborder-trbl"
                data-ref="body"
                id="jeongseondiv"
                role="presentation"
                style={{
                  background: "url(./image/map/basic/basic2_jeongseon.png)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  height: "72px",
                  left: "0px",
                  top: "0px",
                  width: "113px",
                  zIndex: "8",
                }}
              >
                <div
                  className="x-center-target"
                  id="panel-1176-targetEl"
                  role="presentation"
                >
                  <div
                    className="x-field x-form-item x-form-item-default x-form-readonly x-form-type-text x-center-layout-item x-field-default x-center-form-item x-form-item-no-label"
                    id="displayfield-1177"
                    role="presentation"
                    style={{
                      left: "44px",
                      margin: "0px",
                      right: "auto",
                      top: "22px",
                    }}
                  >
                    <div
                      className="x-form-item-body x-form-item-body-default x-form-display-field-body x-form-display-field-body-default"
                      data-ref="bodyEl"
                      id="displayfield-1177-bodyEl"
                      role="presentation"
                    >
                      <div
                        aria-labelledby="displayfield-1177-labelEl"
                        className="dsCenterMapLabel dsCenterMapLabel-default"
                        data-ref="inputEl"
                        id="displayfield-1177-inputEl"
                        role="textbox"
                        tabIndex="-1"
                      >
                        정선
                      </div>
                      <div
                        aria-live="polite"
                        className="x-hidden-clip"
                        data-ref="ariaErrorEl"
                        id="displayfield-1177-ariaErrorEl"
                        role="alert"
                      />
                    </div>
                    <div
                      className="x-form-error-wrap x-form-error-wrap-default x-form-error-wrap-side"
                      data-ref="errorWrapEl"
                      id="displayfield-1177-errorWrapEl"
                      style={{
                        display: "none",
                      }}
                    >
                      <div
                        className="x-form-error-msg x-form-invalid-icon x-form-invalid-icon-default"
                        data-anchortarget="displayfield-1177-inputEl"
                        data-ref="errorEl"
                        id="displayfield-1177-errorEl"
                        role="presentation"
                      />
                    </div>
                  </div>
                  <div
                    className="x-field x-form-item x-form-item-default x-form-readonly x-form-type-text x-center-layout-item x-field-default x-center-form-item x-form-item-no-label"
                    id="DsMainMapMcoValue9"
                    role="presentation"
                    style={{
                      left: "51px",
                      margin: "0px",
                      right: "auto",
                      top: "42px",
                    }}
                  >
                    <div
                      className="x-form-item-body x-form-item-body-default x-form-display-field-body x-form-display-field-body-default"
                      data-ref="bodyEl"
                      id="DsMainMapMcoValue9-bodyEl"
                      role="presentation"
                    >
                      <div
                        aria-labelledby="DsMainMapMcoValue9-labelEl"
                        className="dsCenterMapLabel dsCenterMapLabel-default"
                        data-ref="inputEl"
                        id="jeongseonPotNumber"
                        role="textbox"
                        tabIndex="-1"
                      />
                      <div
                        aria-live="polite"
                        className="x-hidden-clip"
                        data-ref="ariaErrorEl"
                        id="DsMainMapMcoValue9-ariaErrorEl"
                        role="alert"
                      />
                    </div>
                    <div
                      className="x-form-error-wrap x-form-error-wrap-default x-form-error-wrap-side"
                      data-ref="errorWrapEl"
                      id="DsMainMapMcoValue9-errorWrapEl"
                      style={{
                        display: "none",
                      }}
                    >
                      <div
                        className="x-form-error-msg x-form-invalid-icon x-form-invalid-icon-default"
                        data-anchortarget="DsMainMapMcoValue9-inputEl"
                        data-ref="errorEl"
                        id="DsMainMapMcoValue9-errorEl"
                        role="presentation"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="x-panel x-center-layout-item x-panel-default"
              id="nonsanpanel"
              role="presentation"
              style={{
                height: "100px",
                left: "55px",
                margin: "0px",
                right: "auto",
                top: "260px",
                width: "126px",
                zIndex: "8",
              }}
            >
              <div
                className="x-panel-body x-panel-body-default x-panel-body-default x-noborder-trbl"
                data-ref="body"
                id="nonsandiv"
                role="presentation"
                style={{
                  background: "url(./image/map/basic/basic2_nonsan.png)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  height: "100px",
                  left: "0px",
                  top: "0px",
                  width: "121px",
                  zIndex: "8",
                }}
              >
                <div
                  className="x-center-target"
                  id="panel-1178-targetEl"
                  role="presentation"
                >
                  <div
                    className="x-field x-form-item x-form-item-default x-form-readonly x-form-type-text x-center-layout-item x-field-default x-center-form-item x-form-item-no-label"
                    id="displayfield-1179"
                    role="presentation"
                    style={{
                      left: "42px",
                      margin: "0px",
                      right: "auto",
                      top: "26px",
                    }}
                  >
                    <div
                      className="x-form-item-body x-form-item-body-default x-form-display-field-body x-form-display-field-body-default"
                      data-ref="bodyEl"
                      id="displayfield-1179-bodyEl"
                      role="presentation"
                    >
                      <div
                        aria-labelledby="displayfield-1179-labelEl"
                        className="dsCenterMapLabel dsCenterMapLabel-default"
                        data-ref="inputEl"
                        id="displayfield-1179-inputEl"
                        role="textbox"
                        tabIndex="-1"
                      >
                        논산
                      </div>
                      <div
                        aria-live="polite"
                        className="x-hidden-clip"
                        data-ref="ariaErrorEl"
                        id="displayfield-1179-ariaErrorEl"
                        role="alert"
                      />
                    </div>
                    <div
                      className="x-form-error-wrap x-form-error-wrap-default x-form-error-wrap-side"
                      data-ref="errorWrapEl"
                      id="displayfield-1179-errorWrapEl"
                      style={{
                        display: "none",
                      }}
                    >
                      <div
                        className="x-form-error-msg x-form-invalid-icon x-form-invalid-icon-default"
                        data-anchortarget="displayfield-1179-inputEl"
                        data-ref="errorEl"
                        id="displayfield-1179-errorEl"
                        role="presentation"
                      />
                    </div>
                  </div>
                  <div
                    className="x-field x-form-item x-form-item-default x-form-readonly x-form-type-text x-center-layout-item x-field-default x-center-form-item x-form-item-no-label"
                    id="DsMainMapMcoValue10"
                    role="presentation"
                    style={{
                      left: "49px",
                      margin: "0px",
                      right: "auto",
                      top: "46px",
                    }}
                  >
                    <div
                      className="x-form-item-body x-form-item-body-default x-form-display-field-body x-form-display-field-body-default"
                      data-ref="bodyEl"
                      id="DsMainMapMcoValue10-bodyEl"
                      role="presentation"
                    >
                      <div
                        aria-labelledby="DsMainMapMcoValue10-labelEl"
                        className="dsCenterMapLabel dsCenterMapLabel-default"
                        data-ref="inputEl"
                        id="nonsanPotNumber"
                        role="textbox"
                        tabIndex="-1"
                      />
                      <div
                        aria-live="polite"
                        className="x-hidden-clip"
                        data-ref="ariaErrorEl"
                        id="DsMainMapMcoValue10-ariaErrorEl"
                        role="alert"
                      />
                    </div>
                    <div
                      className="x-form-error-wrap x-form-error-wrap-default x-form-error-wrap-side"
                      data-ref="errorWrapEl"
                      id="DsMainMapMcoValue10-errorWrapEl"
                      style={{
                        display: "none",
                      }}
                    >
                      <div
                        className="x-form-error-msg x-form-invalid-icon x-form-invalid-icon-default"
                        data-anchortarget="DsMainMapMcoValue10-inputEl"
                        data-ref="errorEl"
                        id="DsMainMapMcoValue10-errorEl"
                        role="presentation"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="x-panel x-center-layout-item x-panel-default"
              id="jeonjupanel"
              role="presentation"
              style={{
                height: "108px",
                left: "45px",
                margin: "0px",
                right: "auto",
                top: "342px",
                width: "108px",
                zIndex: "8",
              }}
            >
              <div
                className="x-panel-body x-panel-body-default x-panel-body-default x-noborder-trbl"
                data-ref="body"
                id="jeonjudiv"
                role="presentation"
                style={{
                  background: "url(./image/map/basic/basic2_jeonju.png)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  height: "111px",
                  left: "0px",
                  top: "0px",
                  width: "102px",
                  zIndex: "8",
                }}
              >
                <div
                  className="x-center-target"
                  id="panel-1180-targetEl"
                  role="presentation"
                >
                  <div
                    className="x-field x-form-item x-form-item-default x-form-readonly x-form-type-text x-center-layout-item x-field-default x-center-form-item x-form-item-no-label"
                    id="displayfield-1181"
                    role="presentation"
                    style={{
                      left: "39px",
                      margin: "0px",
                      right: "auto",
                      top: "20px",
                    }}
                  >
                    <div
                      className="x-form-item-body x-form-item-body-default x-form-display-field-body x-form-display-field-body-default"
                      data-ref="bodyEl"
                      id="displayfield-1181-bodyEl"
                      role="presentation"
                    >
                      <div
                        aria-labelledby="displayfield-1181-labelEl"
                        className="dsCenterMapLabel dsCenterMapLabel-default"
                        data-ref="inputEl"
                        id="displayfield-1181-inputEl"
                        role="textbox"
                        tabIndex="-1"
                      >
                        전주
                      </div>
                      <div
                        aria-live="polite"
                        className="x-hidden-clip"
                        data-ref="ariaErrorEl"
                        id="displayfield-1181-ariaErrorEl"
                        role="alert"
                      />
                    </div>
                    <div
                      className="x-form-error-wrap x-form-error-wrap-default x-form-error-wrap-side"
                      data-ref="errorWrapEl"
                      id="displayfield-1181-errorWrapEl"
                      style={{
                        display: "none",
                      }}
                    >
                      <div
                        className="x-form-error-msg x-form-invalid-icon x-form-invalid-icon-default"
                        data-anchortarget="displayfield-1181-inputEl"
                        data-ref="errorEl"
                        id="displayfield-1181-errorEl"
                        role="presentation"
                      />
                    </div>
                  </div>
                  <div
                    className="x-field x-form-item x-form-item-default x-form-readonly x-form-type-text x-center-layout-item x-field-default x-center-form-item x-form-item-no-label"
                    id="DsMainMapMcoValue11"
                    role="presentation"
                    style={{
                      left: "47px",
                      margin: "0px",
                      right: "auto",
                      top: "40px",
                    }}
                  >
                    <div
                      className="x-form-item-body x-form-item-body-default x-form-display-field-body x-form-display-field-body-default"
                      data-ref="bodyEl"
                      id="DsMainMapMcoValue11-bodyEl"
                      role="presentation"
                    >
                      <div
                        aria-labelledby="DsMainMapMcoValue11-labelEl"
                        className="dsCenterMapLabel dsCenterMapLabel-default"
                        data-ref="inputEl"
                        id="jeonjuPotNumber"
                        role="textbox"
                        tabIndex="-1"
                      />
                      <div
                        aria-live="polite"
                        className="x-hidden-clip"
                        data-ref="ariaErrorEl"
                        id="DsMainMapMcoValue11-ariaErrorEl"
                        role="alert"
                      />
                    </div>
                    <div
                      className="x-form-error-wrap x-form-error-wrap-default x-form-error-wrap-side"
                      data-ref="errorWrapEl"
                      id="DsMainMapMcoValue11-errorWrapEl"
                      style={{
                        display: "none",
                      }}
                    >
                      <div
                        className="x-form-error-msg x-form-invalid-icon x-form-invalid-icon-default"
                        data-anchortarget="DsMainMapMcoValue11-inputEl"
                        data-ref="errorEl"
                        id="DsMainMapMcoValue11-errorEl"
                        role="presentation"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="x-panel x-center-layout-item x-panel-default"
              id="namwonpanel"
              role="presentation"
              style={{
                height: "99px",
                left: "96px",
                margin: "0px",
                right: "auto",
                top: "354px",
                width: "111px",
                zIndex: "8",
              }}
            >
              <div
                className="x-panel-body x-panel-body-default x-panel-body-default x-noborder-trbl"
                data-ref="body"
                id="namwondiv"
                role="presentation"
                style={{
                  background: "url(./image/map/basic/basic2_namwon.png)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  height: "100px",
                  left: "0px",
                  top: "0px",
                  width: "108px",
                  zIndex: "8",
                }}
              >
                <div
                  className="x-center-target"
                  id="panel-1182-targetEl"
                  role="presentation"
                >
                  <div
                    className="x-field x-form-item x-form-item-default x-form-readonly x-form-type-text x-center-layout-item x-field-default x-center-form-item x-form-item-no-label"
                    id="displayfield-1183"
                    role="presentation"
                    style={{
                      left: "48px",
                      margin: "0px",
                      right: "auto",
                      top: "25px",
                    }}
                  >
                    <div
                      className="x-form-item-body x-form-item-body-default x-form-display-field-body x-form-display-field-body-default"
                      data-ref="bodyEl"
                      id="displayfield-1183-bodyEl"
                      role="presentation"
                    >
                      <div
                        aria-labelledby="displayfield-1183-labelEl"
                        className="dsCenterMapLabel dsCenterMapLabel-default"
                        data-ref="inputEl"
                        id="displayfield-1183-inputEl"
                        role="textbox"
                        tabIndex="-1"
                      >
                        남원
                      </div>
                      <div
                        aria-live="polite"
                        className="x-hidden-clip"
                        data-ref="ariaErrorEl"
                        id="displayfield-1183-ariaErrorEl"
                        role="alert"
                      />
                    </div>
                    <div
                      className="x-form-error-wrap x-form-error-wrap-default x-form-error-wrap-side"
                      data-ref="errorWrapEl"
                      id="displayfield-1183-errorWrapEl"
                      style={{
                        display: "none",
                      }}
                    >
                      <div
                        className="x-form-error-msg x-form-invalid-icon x-form-invalid-icon-default"
                        data-anchortarget="displayfield-1183-inputEl"
                        data-ref="errorEl"
                        id="displayfield-1183-errorEl"
                        role="presentation"
                      />
                    </div>
                  </div>
                  <div
                    className="x-field x-form-item x-form-item-default x-form-readonly x-form-type-text x-center-layout-item x-field-default x-center-form-item x-form-item-no-label"
                    id="DsMainMapMcoValue12"
                    role="presentation"
                    style={{
                      left: "56px",
                      margin: "0px",
                      right: "auto",
                      top: "45px",
                    }}
                  >
                    <div
                      className="x-form-item-body x-form-item-body-default x-form-display-field-body x-form-display-field-body-default"
                      data-ref="bodyEl"
                      id="DsMainMapMcoValue12-bodyEl"
                      role="presentation"
                    >
                      <div
                        aria-labelledby="DsMainMapMcoValue12-labelEl"
                        className="dsCenterMapLabel dsCenterMapLabel-default"
                        data-ref="inputEl"
                        id="namwonPotNumber"
                        role="textbox"
                        tabIndex="-1"
                      />
                      <div
                        aria-live="polite"
                        className="x-hidden-clip"
                        data-ref="ariaErrorEl"
                        id="DsMainMapMcoValue12-ariaErrorEl"
                        role="alert"
                      />
                    </div>
                    <div
                      className="x-form-error-wrap x-form-error-wrap-default x-form-error-wrap-side"
                      data-ref="errorWrapEl"
                      id="DsMainMapMcoValue12-errorWrapEl"
                      style={{
                        display: "none",
                      }}
                    >
                      <div
                        className="x-form-error-msg x-form-invalid-icon x-form-invalid-icon-default"
                        data-anchortarget="DsMainMapMcoValue12-inputEl"
                        data-ref="errorEl"
                        id="DsMainMapMcoValue12-errorEl"
                        role="presentation"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="x-panel x-center-layout-item x-panel-default"
              id="daegupanel"
              role="presentation"
              style={{
                height: "145px",
                left: "199px",
                margin: "0px",
                right: "auto",
                top: "276px",
                width: "138px",
                zIndex: "8",
              }}
            >
              <div
                className="x-panel-body x-panel-body-default x-panel-body-default x-noborder-trbl"
                data-ref="body"
                id="daegudiv"
                role="presentation"
                style={{
                  background: "url(./image/map/basic/basic2_daegu.png)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  height: "142px",
                  left: "0px",
                  top: "0px",
                  width: "135px",
                  zIndex: "8",
                }}
              >
                <div
                  className="x-center-target"
                  id="panel-1184-targetEl"
                  role="presentation"
                >
                  <div
                    className="x-field x-form-item x-form-item-default x-form-readonly x-form-type-text x-center-layout-item x-field-default x-center-form-item x-form-item-no-label"
                    id="displayfield-1185"
                    role="presentation"
                    style={{
                      left: "48px",
                      margin: "0px",
                      right: "auto",
                      top: "44px",
                    }}
                  >
                    <div
                      className="x-form-item-body x-form-item-body-default x-form-display-field-body x-form-display-field-body-default"
                      data-ref="bodyEl"
                      id="displayfield-1185-bodyEl"
                      role="presentation"
                    >
                      <div
                        aria-labelledby="displayfield-1185-labelEl"
                        className="dsCenterMapLabel dsCenterMapLabel-default"
                        data-ref="inputEl"
                        id="displayfield-1185-inputEl"
                        role="textbox"
                        tabIndex="-1"
                      >
                        대구
                      </div>
                      <div
                        aria-live="polite"
                        className="x-hidden-clip"
                        data-ref="ariaErrorEl"
                        id="displayfield-1185-ariaErrorEl"
                        role="alert"
                      />
                    </div>
                    <div
                      className="x-form-error-wrap x-form-error-wrap-default x-form-error-wrap-side"
                      data-ref="errorWrapEl"
                      id="displayfield-1185-errorWrapEl"
                      style={{
                        display: "none",
                      }}
                    >
                      <div
                        className="x-form-error-msg x-form-invalid-icon x-form-invalid-icon-default"
                        data-anchortarget="displayfield-1185-inputEl"
                        data-ref="errorEl"
                        id="displayfield-1185-errorEl"
                        role="presentation"
                      />
                    </div>
                  </div>
                  <div
                    className="x-field x-form-item x-form-item-default x-form-readonly x-form-type-text x-center-layout-item x-field-default x-center-form-item x-form-item-no-label"
                    id="DsMainMapMcoValue13"
                    role="presentation"
                    style={{
                      left: "56px",
                      margin: "0px",
                      right: "auto",
                      top: "64px",
                    }}
                  >
                    <div
                      className="x-form-item-body x-form-item-body-default x-form-display-field-body x-form-display-field-body-default"
                      data-ref="bodyEl"
                      id="DsMainMapMcoValue13-bodyEl"
                      role="presentation"
                    >
                      <div
                        aria-labelledby="DsMainMapMcoValue13-labelEl"
                        className="dsCenterMapLabel dsCenterMapLabel-default"
                        data-ref="inputEl"
                        id="daeguPotNumber"
                        role="textbox"
                        tabIndex="-1"
                      />
                      <div
                        aria-live="polite"
                        className="x-hidden-clip"
                        data-ref="ariaErrorEl"
                        id="DsMainMapMcoValue13-ariaErrorEl"
                        role="alert"
                      />
                    </div>
                    <div
                      className="x-form-error-wrap x-form-error-wrap-default x-form-error-wrap-side"
                      data-ref="errorWrapEl"
                      id="DsMainMapMcoValue13-errorWrapEl"
                      style={{
                        display: "none",
                      }}
                    >
                      <div
                        className="x-form-error-msg x-form-invalid-icon x-form-invalid-icon-default"
                        data-anchortarget="DsMainMapMcoValue13-inputEl"
                        data-ref="errorEl"
                        id="DsMainMapMcoValue13-errorEl"
                        role="presentation"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="x-panel x-center-layout-item x-panel-default"
              id="pohangpanel"
              role="presentation"
              style={{
                height: "211px",
                left: "297px",
                margin: "0px",
                right: "auto",
                top: "204px",
                width: "103px",
                zIndex: "8",
              }}
            >
              <div
                className="x-panel-body x-panel-body-default x-panel-body-default x-noborder-trbl"
                data-ref="body"
                id="pohangdiv"
                role="presentation"
                style={{
                  background: "url(./image/map/basic/basic2_pohang.png)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  height: "204px",
                  left: "0px",
                  top: "0px",
                  width: "95px",
                  zIndex: "8",
                }}
              >
                <div
                  className="x-center-target"
                  id="panel-1186-targetEl"
                  role="presentation"
                >
                  <div
                    className="x-field x-form-item x-form-item-default x-form-readonly x-form-type-text x-center-layout-item x-field-default x-center-form-item x-form-item-no-label"
                    id="displayfield-1187"
                    role="presentation"
                    style={{
                      left: "32px",
                      margin: "0px",
                      right: "auto",
                      top: "101px",
                    }}
                  >
                    <div
                      className="x-form-item-body x-form-item-body-default x-form-display-field-body x-form-display-field-body-default"
                      data-ref="bodyEl"
                      id="displayfield-1187-bodyEl"
                      role="presentation"
                    >
                      <div
                        aria-labelledby="displayfield-1187-labelEl"
                        className="dsCenterMapLabel dsCenterMapLabel-default"
                        data-ref="inputEl"
                        id="displayfield-1187-inputEl"
                        role="textbox"
                        tabIndex="-1"
                      >
                        포항
                      </div>
                      <div
                        aria-live="polite"
                        className="x-hidden-clip"
                        data-ref="ariaErrorEl"
                        id="displayfield-1187-ariaErrorEl"
                        role="alert"
                      />
                    </div>
                    <div
                      className="x-form-error-wrap x-form-error-wrap-default x-form-error-wrap-side"
                      data-ref="errorWrapEl"
                      id="displayfield-1187-errorWrapEl"
                      style={{
                        display: "none",
                      }}
                    >
                      <div
                        className="x-form-error-msg x-form-invalid-icon x-form-invalid-icon-default"
                        data-anchortarget="displayfield-1187-inputEl"
                        data-ref="errorEl"
                        id="displayfield-1187-errorEl"
                        role="presentation"
                      />
                    </div>
                  </div>
                  <div
                    className="x-field x-form-item x-form-item-default x-form-readonly x-form-type-text x-center-layout-item x-field-default x-center-form-item x-form-item-no-label"
                    id="DsMainMapMcoValue14"
                    role="presentation"
                    style={{
                      left: "39px",
                      margin: "0px",
                      right: "auto",
                      top: "121px",
                    }}
                  >
                    <div
                      className="x-form-item-body x-form-item-body-default x-form-display-field-body x-form-display-field-body-default"
                      data-ref="bodyEl"
                      id="DsMainMapMcoValue14-bodyEl"
                      role="presentation"
                    >
                      <div
                        aria-labelledby="DsMainMapMcoValue14-labelEl"
                        className="dsCenterMapLabel dsCenterMapLabel-default"
                        data-ref="inputEl"
                        id="pohangPotNumber"
                        role="textbox"
                        tabIndex="-1"
                      />
                      <div
                        aria-live="polite"
                        className="x-hidden-clip"
                        data-ref="ariaErrorEl"
                        id="DsMainMapMcoValue14-ariaErrorEl"
                        role="alert"
                      />
                    </div>
                    <div
                      className="x-form-error-wrap x-form-error-wrap-default x-form-error-wrap-side"
                      data-ref="errorWrapEl"
                      id="DsMainMapMcoValue14-errorWrapEl"
                      style={{
                        display: "none",
                      }}
                    >
                      <div
                        className="x-form-error-msg x-form-invalid-icon x-form-invalid-icon-default"
                        data-anchortarget="DsMainMapMcoValue14-inputEl"
                        data-ref="errorEl"
                        id="DsMainMapMcoValue14-errorEl"
                        role="presentation"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="x-panel x-center-layout-item x-panel-default"
              id="gwangjupanel"
              role="presentation"
              style={{
                height: "159px",
                left: "7px",
                margin: "0px",
                right: "auto",
                top: "434px",
                width: "128px",
                zIndex: "8",
              }}
            >
              <div
                className="x-panel-body x-panel-body-default x-panel-body-default x-noborder-trbl"
                data-ref="body"
                id="gwangjudiv"
                role="presentation"
                style={{
                  background: "url(./image/map/basic/basic2_gwangju.png)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  height: "159px",
                  left: "0px",
                  top: "0px",
                  width: "120px",
                  zIndex: "8",
                }}
              >
                <div
                  className="x-center-target"
                  id="panel-1188-targetEl"
                  role="presentation"
                >
                  <div
                    className="x-field x-form-item x-form-item-default x-form-readonly x-form-type-text x-center-layout-item x-field-default x-center-form-item x-form-item-no-label"
                    id="displayfield-1189"
                    role="presentation"
                    style={{
                      left: "42px",
                      margin: "0px",
                      right: "auto",
                      top: "51px",
                    }}
                  >
                    <div
                      className="x-form-item-body x-form-item-body-default x-form-display-field-body x-form-display-field-body-default"
                      data-ref="bodyEl"
                      id="displayfield-1189-bodyEl"
                      role="presentation"
                    >
                      <div
                        aria-labelledby="displayfield-1189-labelEl"
                        className="dsCenterMapLabel dsCenterMapLabel-default"
                        data-ref="inputEl"
                        id="displayfield-1189-inputEl"
                        role="textbox"
                        tabIndex="-1"
                      >
                        광주
                      </div>
                      <div
                        aria-live="polite"
                        className="x-hidden-clip"
                        data-ref="ariaErrorEl"
                        id="displayfield-1189-ariaErrorEl"
                        role="alert"
                      />
                    </div>
                    <div
                      className="x-form-error-wrap x-form-error-wrap-default x-form-error-wrap-side"
                      data-ref="errorWrapEl"
                      id="displayfield-1189-errorWrapEl"
                      style={{
                        display: "none",
                      }}
                    >
                      <div
                        className="x-form-error-msg x-form-invalid-icon x-form-invalid-icon-default"
                        data-anchortarget="displayfield-1189-inputEl"
                        data-ref="errorEl"
                        id="displayfield-1189-errorEl"
                        role="presentation"
                      />
                    </div>
                  </div>
                  <div
                    className="x-field x-form-item x-form-item-default x-form-readonly x-form-type-text x-center-layout-item x-field-default x-center-form-item x-form-item-no-label"
                    id="DsMainMapMcoValue15"
                    role="presentation"
                    style={{
                      left: "46px",
                      margin: "0px",
                      right: "auto",
                      top: "71px",
                    }}
                  >
                    <div
                      className="x-form-item-body x-form-item-body-default x-form-display-field-body x-form-display-field-body-default"
                      data-ref="bodyEl"
                      id="DsMainMapMcoValue15-bodyEl"
                      role="presentation"
                    >
                      <div
                        aria-labelledby="DsMainMapMcoValue15-labelEl"
                        className="dsCenterMapLabel dsCenterMapLabel-default"
                        data-ref="inputEl"
                        id="gwangjuPotNumber"
                        role="textbox"
                        tabIndex="-1"
                      />
                      <div
                        aria-live="polite"
                        className="x-hidden-clip"
                        data-ref="ariaErrorEl"
                        id="DsMainMapMcoValue15-ariaErrorEl"
                        role="alert"
                      />
                    </div>
                    <div
                      className="x-form-error-wrap x-form-error-wrap-default x-form-error-wrap-side"
                      data-ref="errorWrapEl"
                      id="DsMainMapMcoValue15-errorWrapEl"
                      style={{
                        display: "none",
                      }}
                    >
                      <div
                        className="x-form-error-msg x-form-invalid-icon x-form-invalid-icon-default"
                        data-anchortarget="DsMainMapMcoValue15-inputEl"
                        data-ref="errorEl"
                        id="DsMainMapMcoValue15-errorEl"
                        role="presentation"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="x-panel x-center-layout-item x-panel-default"
              id="suncheonpanel"
              role="presentation"
              style={{
                height: "124px",
                left: "80px",
                margin: "0px",
                right: "auto",
                top: "450px",
                width: "114px",
                zIndex: "8",
              }}
            >
              <div
                className="x-panel-body x-panel-body-default x-panel-body-default x-noborder-trbl"
                data-ref="body"
                id="suncheondiv"
                role="presentation"
                style={{
                  background: "url(./image/map/basic/basic2_suncheon.png)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  height: "121px",
                  left: "0px",
                  top: "0px",
                  width: "113px",
                  zIndex: "8",
                }}
              >
                <div
                  className="x-center-target"
                  id="panel-1190-targetEl"
                  role="presentation"
                >
                  <div
                    className="x-field x-form-item x-form-item-default x-form-readonly x-form-type-text x-center-layout-item x-field-default x-center-form-item x-form-item-no-label"
                    id="displayfield-1191"
                    role="presentation"
                    style={{
                      left: "54px",
                      margin: "0px",
                      right: "auto",
                      top: "20px",
                    }}
                  >
                    <div
                      className="x-form-item-body x-form-item-body-default x-form-display-field-body x-form-display-field-body-default"
                      data-ref="bodyEl"
                      id="displayfield-1191-bodyEl"
                      role="presentation"
                    >
                      <div
                        aria-labelledby="displayfield-1191-labelEl"
                        className="dsCenterMapLabel dsCenterMapLabel-default"
                        data-ref="inputEl"
                        id="displayfield-1191-inputEl"
                        role="textbox"
                        tabIndex="-1"
                      >
                        순천
                      </div>
                      <div
                        aria-live="polite"
                        className="x-hidden-clip"
                        data-ref="ariaErrorEl"
                        id="displayfield-1191-ariaErrorEl"
                        role="alert"
                      />
                    </div>
                    <div
                      className="x-form-error-wrap x-form-error-wrap-default x-form-error-wrap-side"
                      data-ref="errorWrapEl"
                      id="displayfield-1191-errorWrapEl"
                      style={{
                        display: "none",
                      }}
                    >
                      <div
                        className="x-form-error-msg x-form-invalid-icon x-form-invalid-icon-default"
                        data-anchortarget="displayfield-1191-inputEl"
                        data-ref="errorEl"
                        id="displayfield-1191-errorEl"
                        role="presentation"
                      />
                    </div>
                  </div>
                  <div
                    className="x-field x-form-item x-form-item-default x-form-readonly x-form-type-text x-center-layout-item x-field-default x-center-form-item x-form-item-no-label"
                    id="DsMainMapMcoValue16"
                    role="presentation"
                    style={{
                      left: "58px",
                      margin: "0px",
                      right: "auto",
                      top: "40px",
                    }}
                  >
                    <div
                      className="x-form-item-body x-form-item-body-default x-form-display-field-body x-form-display-field-body-default"
                      data-ref="bodyEl"
                      id="DsMainMapMcoValue16-bodyEl"
                      role="presentation"
                    >
                      <div
                        aria-labelledby="DsMainMapMcoValue16-labelEl"
                        className="dsCenterMapLabel dsCenterMapLabel-default"
                        data-ref="inputEl"
                        id="suncheonPotNumber"
                        role="textbox"
                        tabIndex="-1"
                      />
                      <div
                        aria-live="polite"
                        className="x-hidden-clip"
                        data-ref="ariaErrorEl"
                        id="DsMainMapMcoValue16-ariaErrorEl"
                        role="alert"
                      />
                    </div>
                    <div
                      className="x-form-error-wrap x-form-error-wrap-default x-form-error-wrap-side"
                      data-ref="errorWrapEl"
                      id="DsMainMapMcoValue16-errorWrapEl"
                      style={{
                        display: "none",
                      }}
                    >
                      <div
                        className="x-form-error-msg x-form-invalid-icon x-form-invalid-icon-default"
                        data-anchortarget="DsMainMapMcoValue16-inputEl"
                        data-ref="errorEl"
                        id="DsMainMapMcoValue16-errorEl"
                        role="presentation"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="x-panel x-center-layout-item x-panel-default"
              id="jinjupanel"
              role="presentation"
              style={{
                height: "141px",
                left: "172px",
                margin: "0px",
                right: "auto",
                top: "376px",
                width: "103px",
                zIndex: "8",
              }}
            >
              <div
                className="x-panel-body x-panel-body-default x-panel-body-default x-noborder-trbl"
                data-ref="body"
                id="jinjudiv"
                role="presentation"
                style={{
                  background: "url(./image/map/basic/basic2_jinju.png)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  height: "139px",
                  left: "0px",
                  top: "0px",
                  width: "101px",
                  zIndex: "8",
                }}
              >
                <div
                  className="x-center-target"
                  id="panel-1192-targetEl"
                  role="presentation"
                >
                  <div
                    className="x-field x-form-item x-form-item-default x-form-readonly x-form-type-text x-center-layout-item x-field-default x-center-form-item x-form-item-no-label"
                    id="displayfield-1193"
                    role="presentation"
                    style={{
                      left: "28px",
                      margin: "0px",
                      right: "auto",
                      top: "43px",
                    }}
                  >
                    <div
                      className="x-form-item-body x-form-item-body-default x-form-display-field-body x-form-display-field-body-default"
                      data-ref="bodyEl"
                      id="displayfield-1193-bodyEl"
                      role="presentation"
                    >
                      <div
                        aria-labelledby="displayfield-1193-labelEl"
                        className="dsCenterMapLabel dsCenterMapLabel-default"
                        data-ref="inputEl"
                        id="displayfield-1193-inputEl"
                        role="textbox"
                        tabIndex="-1"
                      >
                        진주
                      </div>
                      <div
                        aria-live="polite"
                        className="x-hidden-clip"
                        data-ref="ariaErrorEl"
                        id="displayfield-1193-ariaErrorEl"
                        role="alert"
                      />
                    </div>
                    <div
                      className="x-form-error-wrap x-form-error-wrap-default x-form-error-wrap-side"
                      data-ref="errorWrapEl"
                      id="displayfield-1193-errorWrapEl"
                      style={{
                        display: "none",
                      }}
                    >
                      <div
                        className="x-form-error-msg x-form-invalid-icon x-form-invalid-icon-default"
                        data-anchortarget="displayfield-1193-inputEl"
                        data-ref="errorEl"
                        id="displayfield-1193-errorEl"
                        role="presentation"
                      />
                    </div>
                  </div>
                  <div
                    className="x-field x-form-item x-form-item-default x-form-readonly x-form-type-text x-center-layout-item x-field-default x-center-form-item x-form-item-no-label"
                    id="DsMainMapMcoValue17"
                    role="presentation"
                    style={{
                      left: "36px",
                      margin: "0px",
                      right: "auto",
                      top: "63px",
                    }}
                  >
                    <div
                      className="x-form-item-body x-form-item-body-default x-form-display-field-body x-form-display-field-body-default"
                      data-ref="bodyEl"
                      id="DsMainMapMcoValue17-bodyEl"
                      role="presentation"
                    >
                      <div
                        aria-labelledby="DsMainMapMcoValue17-labelEl"
                        className="dsCenterMapLabel dsCenterMapLabel-default"
                        data-ref="inputEl"
                        id="jinjuPotNumber"
                        role="textbox"
                        tabIndex="-1"
                      />
                      <div
                        aria-live="polite"
                        className="x-hidden-clip"
                        data-ref="ariaErrorEl"
                        id="DsMainMapMcoValue17-ariaErrorEl"
                        role="alert"
                      />
                    </div>
                    <div
                      className="x-form-error-wrap x-form-error-wrap-default x-form-error-wrap-side"
                      data-ref="errorWrapEl"
                      id="DsMainMapMcoValue17-errorWrapEl"
                      style={{
                        display: "none",
                      }}
                    >
                      <div
                        className="x-form-error-msg x-form-invalid-icon x-form-invalid-icon-default"
                        data-anchortarget="DsMainMapMcoValue17-inputEl"
                        data-ref="errorEl"
                        id="DsMainMapMcoValue17-errorEl"
                        role="presentation"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="x-panel x-center-layout-item x-panel-default"
              id="jinyeongpanel"
              role="presentation"
              style={{
                height: "86px",
                left: "253px",
                margin: "0px",
                right: "auto",
                top: "400px",
                width: "126px",
                zIndex: "8",
              }}
            >
              <div
                className="x-panel-body x-panel-body-default x-panel-body-default x-noborder-trbl"
                data-ref="body"
                id="jinyeongdiv"
                role="presentation"
                style={{
                  background: "url(./image/map/basic/basic2_jinyeong.png)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  height: "88px",
                  left: "0px",
                  top: "0px",
                  width: "127px",
                  zIndex: "8",
                }}
              >
                <div
                  className="x-center-target"
                  id="panel-1194-targetEl"
                  role="presentation"
                >
                  <div
                    className="x-field x-form-item x-form-item-default x-form-readonly x-form-type-text x-center-layout-item x-field-default x-center-form-item x-form-item-no-label"
                    id="displayfield-1195"
                    role="presentation"
                    style={{
                      left: "45px",
                      margin: "0px",
                      right: "auto",
                      top: "26px",
                    }}
                  >
                    <div
                      className="x-form-item-body x-form-item-body-default x-form-display-field-body x-form-display-field-body-default"
                      data-ref="bodyEl"
                      id="displayfield-1195-bodyEl"
                      role="presentation"
                    >
                      <div
                        aria-labelledby="displayfield-1195-labelEl"
                        className="dsCenterMapLabel dsCenterMapLabel-default"
                        data-ref="inputEl"
                        id="displayfield-1195-inputEl"
                        role="textbox"
                        tabIndex="-1"
                      >
                        진영
                      </div>
                      <div
                        aria-live="polite"
                        className="x-hidden-clip"
                        data-ref="ariaErrorEl"
                        id="displayfield-1195-ariaErrorEl"
                        role="alert"
                      />
                    </div>
                    <div
                      className="x-form-error-wrap x-form-error-wrap-default x-form-error-wrap-side"
                      data-ref="errorWrapEl"
                      id="displayfield-1195-errorWrapEl"
                      style={{
                        display: "none",
                      }}
                    >
                      <div
                        className="x-form-error-msg x-form-invalid-icon x-form-invalid-icon-default"
                        data-anchortarget="displayfield-1195-inputEl"
                        data-ref="errorEl"
                        id="displayfield-1195-errorEl"
                        role="presentation"
                      />
                    </div>
                  </div>
                  <div
                    className="x-field x-form-item x-form-item-default x-form-readonly x-form-type-text x-center-layout-item x-field-default x-center-form-item x-form-item-no-label"
                    id="DsMainMapMcoValue18"
                    role="presentation"
                    style={{
                      left: "52px",
                      margin: "0px",
                      right: "auto",
                      top: "46px",
                    }}
                  >
                    <div
                      className="x-form-item-body x-form-item-body-default x-form-display-field-body x-form-display-field-body-default"
                      data-ref="bodyEl"
                      id="DsMainMapMcoValue18-bodyEl"
                      role="presentation"
                    >
                      <div
                        aria-labelledby="DsMainMapMcoValue18-labelEl"
                        className="dsCenterMapLabel dsCenterMapLabel-default"
                        data-ref="inputEl"
                        id="jinyeongPotNumber"
                        role="textbox"
                        tabIndex="-1"
                      />
                      <div
                        aria-live="polite"
                        className="x-hidden-clip"
                        data-ref="ariaErrorEl"
                        id="DsMainMapMcoValue18-ariaErrorEl"
                        role="alert"
                      />
                    </div>
                    <div
                      className="x-form-error-wrap x-form-error-wrap-default x-form-error-wrap-side"
                      data-ref="errorWrapEl"
                      id="DsMainMapMcoValue18-errorWrapEl"
                      style={{
                        display: "none",
                      }}
                    >
                      <div
                        className="x-form-error-msg x-form-invalid-icon x-form-invalid-icon-default"
                        data-anchortarget="DsMainMapMcoValue18-inputEl"
                        data-ref="errorEl"
                        id="DsMainMapMcoValue18-errorEl"
                        role="presentation"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="x-panel x-center-layout-item x-panel-default"
              id="panel-1196"
              role="presentation"
              style={{
                height: "43px",
                left: "234px",
                margin: "0px",
                right: "auto",
                top: "517px",
                width: "74px",
              }}
            >
              <div
                className="x-panel-body x-panel-body-default x-panel-body-default x-noborder-trbl"
                data-ref="body"
                id="panel-1196-body"
                role="presentation"
                style={{
                  background: "url()",
                  height: "43px",
                  left: "0px",
                  top: "0px",
                  width: "74px",
                  zIndex: "8",
                }}
              >
                <div
                  className="x-center-target"
                  id="panel-1196-targetEl"
                  role="presentation"
                >
                  <div
                    className="x-field x-form-item x-form-item-default x-form-readonly x-form-type-text x-center-layout-item x-field-default x-center-form-item x-form-item-no-label"
                    id="displayfield-1197"
                    role="presentation"
                    style={{
                      left: "26px",
                      margin: "0px",
                      right: "auto",
                      top: "0px",
                    }}
                  >
                    <label
                      className="x-form-item-label x-form-item-label-default x-unselectable"
                      data-ref="labelEl"
                      htmlFor="displayfield-1197-inputEl"
                      id="displayfield-1197-labelEl"
                      style={{
                        paddingRight: "5px",
                        width: "105px",
                      }}
                    >
                      <span
                        className="x-form-item-label-inner x-form-item-label-inner-default"
                        style={{
                          width: "100px",
                        }}
                      />
                    </label>
                    <div
                      className="x-form-item-body x-form-item-body-default x-form-display-field-body x-form-display-field-body-default"
                      data-ref="bodyEl"
                      id="displayfield-1197-bodyEl"
                      role="presentation"
                    >
                      <div
                        aria-labelledby="displayfield-1197-labelEl"
                        className="x-form-display-field x-form-display-field-default"
                        data-ref="inputEl"
                        id="displayfield-1197-inputEl"
                        role="textbox"
                        style={{
                          color: "transparent",
                        }}
                        tabIndex="-1"
                      >
                        제주
                      </div>
                      <div
                        aria-live="polite"
                        className="x-hidden-clip"
                        data-ref="ariaErrorEl"
                        id="displayfield-1197-ariaErrorEl"
                        role="alert"
                      />
                    </div>
                    <div
                      className="x-form-error-wrap x-form-error-wrap-default x-form-error-wrap-side"
                      data-ref="errorWrapEl"
                      id="displayfield-1197-errorWrapEl"
                      style={{
                        display: "none",
                      }}
                    >
                      <div
                        className="x-form-error-msg x-form-invalid-icon x-form-invalid-icon-default"
                        data-anchortarget="displayfield-1197-inputEl"
                        data-ref="errorEl"
                        id="displayfield-1197-errorEl"
                        role="presentation"
                      />
                    </div>
                  </div>
                  <div
                    className="x-field x-form-item x-form-item-default x-form-readonly x-form-type-text x-center-layout-item x-field-default x-center-form-item x-form-item-no-label"
                    id="DsMainMapMcoValue19"
                    role="presentation"
                    style={{
                      left: "33px",
                      margin: "0px",
                      right: "auto",
                      top: "18px",
                    }}
                  >
                    <label
                      className="x-form-item-label x-form-item-label-default x-unselectable"
                      data-ref="labelEl"
                      htmlFor="DsMainMapMcoValue19-inputEl"
                      id="DsMainMapMcoValue19-labelEl"
                      style={{
                        paddingRight: "5px",
                        width: "105px",
                      }}
                    >
                      <span
                        className="x-form-item-label-inner x-form-item-label-inner-default"
                        style={{
                          width: "100px",
                        }}
                      />
                    </label>
                    <div
                      className="x-form-item-body x-form-item-body-default x-form-display-field-body x-form-display-field-body-default"
                      data-ref="bodyEl"
                      id="DsMainMapMcoValue19-bodyEl"
                      role="presentation"
                    >
                      <div
                        aria-labelledby="DsMainMapMcoValue19-labelEl"
                        className="x-form-display-field x-form-display-field-default"
                        data-ref="inputEl"
                        id="DsMainMapMcoValue19-inputEl"
                        role="textbox"
                        style={{
                          color: "transparent",
                        }}
                        tabIndex="-1"
                      >
                        0
                      </div>
                      <div
                        aria-live="polite"
                        className="x-hidden-clip"
                        data-ref="ariaErrorEl"
                        id="DsMainMapMcoValue19-ariaErrorEl"
                        role="alert"
                      />
                    </div>
                    <div
                      className="x-form-error-wrap x-form-error-wrap-default x-form-error-wrap-side"
                      data-ref="errorWrapEl"
                      id="DsMainMapMcoValue19-errorWrapEl"
                      style={{
                        display: "none",
                      }}
                    >
                      <div
                        className="x-form-error-msg x-form-invalid-icon x-form-invalid-icon-default"
                        data-anchortarget="DsMainMapMcoValue19-inputEl"
                        data-ref="errorEl"
                        id="DsMainMapMcoValue19-errorEl"
                        role="presentation"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </StyledMap>
  );
};
